module.exports = __WEBPACK_EXTERNAL_MODULE_ramda__;